import React from "react";
import bg from "./bg.png";

class HJZ extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = {
            urlOps: {},
        };
    }

    componentDidMount() {}

    render() {
        return (
            <div className="HJZBox">
                <img
                    src={bg}
                    style={{
                        width: "100%",
                        userSelect: "none",
                        pointerEvents: "none",
                    }}
                />
            </div>
        );
    }
}
export default HJZ;



// WEBPACK FOOTER //
// ./src/staticPage/HJZ/index.js